import React, { useState } from 'react';

const ImageChecker = ({ src, alt, fallbackMessage, className }) => {
  const [imageLoaded, setImageLoaded] = useState(false);
  const [imageError, setImageError] = useState(false);

  const handleImageLoad = () => {
    setImageLoaded(true);
  };

  const handleImageError = () => {
    // setImageError(true);
  };

  return (
    <div style={{border: '1px solid black', width: '220px', height: '130px', display: 'flex', justifyContent: 'center', alignItems: 'center', textAlign: 'justify'}} className={`bg-black flex justify-center items-center text-justify ${className} rounded-md`}>
      <img
        src={src}
        alt={alt}
        className={`w-full ${imageLoaded && !imageError ? 'block' : 'hidden'}`}
        onLoad={handleImageLoad}
        onError={handleImageError}
      />
      {imageError && (
        <p className="text-[16px] text-[#8a1e1e]">{fallbackMessage}</p>
      )}
    </div>
  );
};

export default ImageChecker;
